import React from "react";
import {getTransferGroupData} from "../../../utils/TransferGroupUtils";

export default function TransferCounterComponent({
    value,
    object,
    selectedItem,
}) {
    const getClassName = () => {
        let className = "";
        // loszka dołączona do grupy bez wcześniejszej grupy (OldGroupID === AnmID) -> zwykłe przeniesienie, bez koloru
        const {NewGroupID: newGroupID, OldGroupID: oldGroupID} =
            getTransferGroupData(object);
        const initial = object?.EvData?.initial;
        const groupID = selectedItem?.AnmGrp;
        if (oldGroupID !== groupID) {
            if (
                initial ||
                newGroupID === groupID ||
                (oldGroupID && oldGroupID !== groupID)
            )
                className = "color-success";
            else if (oldGroupID === groupID) className = "color-error";
        }
        return className;
    };

    const className = getClassName();

    return <span className={className}>{value || null}</span>;
}
